module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="tipping-tips-collection-empty">\n	This round is not included in the Streak competition\n</div>';
}
return __p;
};
